import styled from 'styled-components';
import { ShoppingCartOutlined as ShoppingCartOutlinedIcon } from '@ant-design/icons';
import { BREAKPOINTS } from 'constants/Global/Breakpoints.const';

export const CartButton = styled.button.attrs({ type: 'button' })<{
  $count: number;
}>`
  position: relative;
  width: 32px;
  height: 32px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  border-radius: 2px;
  background-color: #f78e1e;
  border: 0;
  cursor: pointer;

  &::after {
    content: '${({ count }) => count || '0'}';
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 16px;
    height: 16px;
    background-color: #fadb14;
    font-family: Roboto;
    font-style: normal;
    font-weight: bold;
    font-size: 0.75rem;
    border-radius: 100%;
    border: 1.5px solid #fff;
    top: -25%;
    left: calc(100% - 8px);
  }

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    width: 94px;
  }
`;

export const Text = styled.span<{ $small?: boolean }>`
  display: none;
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 0.875rem;
  color: #fff;

  @media (min-width: ${BREAKPOINTS.tabletMini}) {
    display: block;
  }
`;

export const ShoppingCartOutlined = styled(ShoppingCartOutlinedIcon)`
  svg {
    width: 20px;
    height: 20px;
    color: #fff;
  }
`;
